import { useState } from 'react';
import { ContentHeader, Table } from '@app/shared';

import { useRefreshAccountStatusDefinitions } from '@app/sdk';
import { ComponentErrorBoundary } from '@app/utilities';
import { ColDef } from 'ag-grid-community';
import { MasterDetailLayout } from '../../components/MasterDetailLayout';
import { Segment } from 'semantic-ui-react';
import { useAccountFlagDefinitions } from '../../../../sdk/tms/referenceData/UseAccountFlagDefinitions';
import { AccountFlagDefinitionForm } from './AccountFlagDefinitionForm';

export function AccountFlagDefinitions() {
  const [selectedAccountFlagDefinition, setSelectedAccountFlagDefinition] = useState(undefined as any);
  const { data: accountFlagDefinitions } = useAccountFlagDefinitions();
  const refreshAccountStatusDefinitions = useRefreshAccountStatusDefinitions();

  const columnDefs: ColDef[] = [
    { field: 'id', headerName: 'Id' },
    { field: 'key', headerName: 'Key' },
    { field: 'description', headerName: 'Description' },
    { field: 'usage', headerName: 'Usage' },
  ];

  const master = (
    <>
      <ContentHeader>
        Account Flag Definitions
        <button className={'ui button'} onClick={() => setSelectedAccountFlagDefinition(undefined)} disabled>
          Add New
        </button>
      </ContentHeader>

      <div style={{ height: 'calc(100% - 100px)' }}>
        <Table items={accountFlagDefinitions} onSelectItem={setSelectedAccountFlagDefinition} columnDefs={columnDefs} />
      </div>
    </>
  );

  const detail = (
    <Segment>
      <ContentHeader>Account Flag Definitions</ContentHeader>
      <AccountFlagDefinitionForm
        key={JSON.stringify(selectedAccountFlagDefinition)}
        accountFlagDefinition={selectedAccountFlagDefinition}
        onUpdate={refreshAccountStatusDefinitions}
      />
    </Segment>
  );

  return (
    <ComponentErrorBoundary>
      <MasterDetailLayout master={master} detail={detail} />
    </ComponentErrorBoundary>
  );
}
